import { useState, useEffect } from 'react';
import { api } from '../../../services/api';

interface Client {
  id: string;
  nom: string;
  telephone: string;
}

interface FormulaireClientProps {
  nom: string;
  telephone: string;
  onNomChange: (v: string) => void;
  onTelChange: (v: string) => void;
  onClientSelect?: (clientId: string) => void;
}

export default function FormulaireClient({ nom, telephone, onNomChange, onTelChange, onClientSelect }: FormulaireClientProps) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [clients, setClients] = useState<Client[]>([]);

  useEffect(() => {
    const token = localStorage.getItem('atelier_bassoum_token');
    if (token) {
        api.getClients(token).then(data => {
            setClients(data.map((c: any) => ({
                id: String(c.id),
                nom: c.nom,
                telephone: c.telephone
            })));
        }).catch(() => {});
    }
  }, []);

  const suggestions = nom.length >= 2
    ? clients.filter(c => c.nom.toLowerCase().includes(nom.toLowerCase()))
    : [];

  const selectClient = (client: Client) => {
    onNomChange(client.nom);
    onTelChange(client.telephone);
    if (onClientSelect) onClientSelect(client.id);
    setShowSuggestions(false);
  };

  return (
    <div className="grid gap-4">
      <div className="relative">
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
          Nom complet <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
            <i className="ri-user-line" />
          </div>
          <input
            type="text"
            value={nom}
            onChange={e => { onNomChange(e.target.value); setShowSuggestions(true); if (onClientSelect) onClientSelect(''); }}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
            placeholder="ex: Aminata Coulibaly"
            className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-foret-400 bg-gray-50"
          />
        </div>
        {showSuggestions && suggestions.length > 0 && (
          <div className="absolute z-20 top-full mt-1 w-full bg-white border border-gray-200 rounded-xl overflow-hidden shadow-xl max-h-60 overflow-y-auto">
            {suggestions.map(c => (
              <button
                key={c.id}
                onMouseDown={() => selectClient(c)}
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-foret-50 text-left transition-colors cursor-pointer border-b border-gray-50 last:border-0"
              >
                <div className="w-8 h-8 rounded-full bg-terre-100 flex items-center justify-center text-terre-600 text-[10px] font-bold flex-shrink-0">
                  {c.nom.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-800">{c.nom}</p>
                  <p className="text-[11px] text-gray-500">{c.telephone}</p>
                </div>
                <div className="ml-auto text-[10px] text-foret-500 font-bold bg-foret-50 px-1.5 py-0.5 rounded-full">Existant</div>
              </button>
            ))}
          </div>
        )}
      </div>
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
          Téléphone <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
            <i className="ri-phone-line" />
          </div>
          <input
            type="tel"
            value={telephone}
            onChange={e => onTelChange(e.target.value)}
            placeholder="+223 7X XX XX XX"
            className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-foret-400 bg-gray-50"
          />
        </div>
      </div>
    </div>
  );
}
